<template lang="pug">
  .b-json(
    v-if="showJSON"
  )
    .b-json__outline(
      @click="showJSON = false"
    )
    .b-json__content
      .b-json__title App data
      JsonViewer(
        :key="importDate && date"
        :value="items"
        :expand-depth="5"
        copyable
        :sort="false"
      )
    .b-json__content
      .b-json__title Export
      JsonViewer(
        :key="importDate && date"
        :value="exportItems"
        :expand-depth="5"
        copyable
        :sort="false"
      )
    .b-json__content
      .b-json__title Import
      .b-json__import
        textarea-autosize.b-import-textarea(
          v-model="importedJSON"
          @input.native="runImport"
        )
</template>

<script>
import JsonViewer from 'vue-json-viewer';
import { mapFields } from 'vuex-map-fields';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'JSON',
  components: {
    JsonViewer,
  },
  computed: {
    ...mapFields('showJSON', [
      'showJSON',
    ]),
    ...mapFields('nodes', [
      'date',
      'items',
    ]),
    ...mapGetters('nodes', [
      'exportItems',
    ]),
    ...mapFields('importJSON', [
      'importDate',
      'importedJSON',
    ]),
  },
  methods: {
    ...mapActions('importJSON', [
      'runImport',
    ]),
    eventPressEsc(event) {
      if (event.keyCode === 27) {
        this.showJSON = false;
      }
    },
    initEvents() {
      if (this.showJSON) {
        document.addEventListener('keydown', this.eventPressEsc);
      } else {
        document.removeEventListener('keydown', this.eventPressEsc);
      }
    },
  },
  watch: {
    showJSON() {
      this.initEvents();
    },
  },
};
</script>
